module.exports = __webpack_public_path__ + "img/contactBanner.980ea312.jpg";